module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "value": "true",
        "exact": ""
      },
      on: {
        "click": function($event) {
          _vm.handleListClick(item)
        }
      }
    }, [_c('v-list-tile', [_c('v-icon', {
      attrs: {
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(_vm.$t(item.title))
      }
    })], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "color": _vm.themeColor
    }
  }, [(_vm.isShowMenu) ? _c('v-toolbar-side-icon', {
    staticClass: "white--text",
    attrs: {
      "light": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDrawer($event)
      }
    }
  }) : (!_vm.isMainPage) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("home")]), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "white--text",
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.title))
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "close-on-click": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(_vm.isCustomPage) ? [_c('v-list-tile', {
    on: {
      "click": _vm.openSaveWindow
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("save")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    }
  })], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.openDeleteWindow
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    }
  })], 1)] : [(_vm.routeName != 'Settings') ? _c('v-list-tile', {
    on: {
      "click": _vm.goSettings
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('Settings'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$bus.isShowAboutMe = true
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("info")])], 1), _vm._v(" "), _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.$t('About Me'))
    }
  })], 1)]], 2)], 1)], 1), _vm._v(" "), _c('v-content', [_c('router-view'), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "color": _vm.snackbar.color
    },
    model: {
      value: (_vm.snackbar.isOpen),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "isOpen", $$v)
      },
      expression: "snackbar.isOpen"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbar.msg) + "\n    ")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.$bus.isUpdate),
      callback: function($$v) {
        _vm.$set(_vm.$bus, "isUpdate", $$v)
      },
      expression: "$bus.isUpdate"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline justify-center"
  }, [_vm._v("\n          Updating\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    staticClass: "text-xs-center text-md-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": _vm.themeColor
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "290"
    },
    model: {
      value: (_vm.$bus.isShowAboutMe),
      callback: function($$v) {
        _vm.$set(_vm.$bus, "isShowAboutMe", $$v)
      },
      expression: "$bus.isShowAboutMe"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline justify-center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('About Me')) + "\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t('Thank You For Using This. Any Fallback Is Welcome 😊')))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://github.com/roysung",
      "target": "block"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("fa-github")]), _vm._v("\n              RoySung\n            ")], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 432
// module chunks = 1